import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CoreModule } from '../core/core.module';

import { TranslatePipe } from './translate.pipe';
import { ProductDescriptionTextComponent } from './product-description-text/product-description-text.component';
import { PlateColorpickerComponent } from './plate-colorpicker/plate-colorpicker.component';
import { RalColorpickerComponent } from './ral-colorpicker/ral-colorpicker.component';
import { PlateColorpickerDialogComponent } from './plate-colorpicker-dialog/plate-colorpicker-dialog.component';
import { ViegaCommonModule } from 'viega-common';

@NgModule({
    imports: [
        CoreModule,
        CommonModule,
        ViegaCommonModule,
    ],
    declarations: [
        PlateColorpickerComponent,
        RalColorpickerComponent,
        ProductDescriptionTextComponent,
        PlateColorpickerDialogComponent,

        TranslatePipe
    ],
    exports: [
        PlateColorpickerComponent,
        RalColorpickerComponent,
        ProductDescriptionTextComponent,

        TranslatePipe,
    ],
    providers: [],
    entryComponents: [
        PlateColorpickerDialogComponent,
    ]
})
export class SharedModule {}



// WEBPACK FOOTER //
// ./src/app/shared/shared.module.ts